/* eslint-disable */
import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import AppButton from 'Shared/UI/Button';
import DropdownSelect from 'Shared/UI/DropdownSelect';
import searchIcon from 'Images/search_icon.svg';
import UserAdd from './UserAdd';
import UserList from './UserList';

const STATUT_OPTIONS = [
  { value: 'active', label: 'Activé' },
  { value: 'inactive', label: 'Désactivé' },
];

const AMF_OPTIONS = [
  { value: 'required', label: 'Requis' },
  { value: 'enabled', label: 'Activé' },
];

const Users = () => {
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [user, setUser] = useState();

  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [selectedStatuts, setSelectedStatuts] = useState([]);
  const [selectedAmf, setSelectedAmf] = useState([]);
  const debounceRef = useRef(null);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setDebouncedSearch(val), 350);
  };

  const handleClose = () => {
    setOpen(false);
    setUser(undefined);
  };

  const selectUser = (u) => () => {
    setUser(u);
    setOpen(true);
  };

  const handleReset = () => {
    setSearch('');
    setDebouncedSearch('');
    setSelectedStatuts([]);
    setSelectedAmf([]);
  };

  useEffect(() => {
    const interval = setInterval(() => setUpdate((prev) => !prev), 60000);
    return () => clearInterval(interval);
  }, []);

  const filters = useMemo(() => {
    const isCode = /^\d/.test(debouncedSearch);
    return {
      name: isCode ? '' : debouncedSearch,
      code: isCode ? debouncedSearch : '',
      status: selectedStatuts.length === 1 ? selectedStatuts[0] : '',
      mfa: selectedAmf.length === 1 ? selectedAmf[0] : '',
    };
  }, [debouncedSearch, selectedStatuts, selectedAmf]);

  return (
    <Box sx={{
      px: { xs: '16px', md: '40px' }, py: '16px',
      backgroundColor: '#F8FAFC',
    }}>
      {open && <UserAdd handleClose={handleClose} user={user} updateList={setUpdate} />}

      {/* Header */}
      <Box sx={{ mb: '16px', flexShrink: 0 }}>
        <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#000000' }}>
          Gestion des utilisateurs
        </Typography>
        <Typography sx={{ fontSize: '13px', color: '#385576', fontWeight: 600, mt: '-2px' }}>
          Gérez les comptes et les permissions
        </Typography>
      </Box>

      {/* Filter bar */}
      <Box sx={{
        px: '4px', py: '4px', backgroundColor: '#FFFFFF',
        border: '1px solid #D1D5DB',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        flexWrap: 'wrap',
        mb: '12px',
        flexShrink: 0,
      }}>
        {/* Search */}
        <Box sx={{
          flex: 1,
          minWidth: 220,
          height: '45px',
          display: 'flex', alignItems: 'center',
          border: '1px solid #DEE5EE', borderRadius: '8px',
          px: '12px', gap: '8px',
          backgroundColor: '#F8FAFC',
        }}>
          <img src={searchIcon} alt="search" style={{ width: 20, height: 20, flexShrink: 0, objectFit: 'contain' }} />
          <input
            placeholder="Rechercher par code client ou nom..."
            value={search}
            onChange={handleSearchChange}
            style={{
              border: 'none', outline: 'none', background: 'transparent',
              fontSize: '13px', color: '#1A2035', width: '100%',
            }}
          />
        </Box>

        {/* Statut */}
        <DropdownSelect
          options={STATUT_OPTIONS}
          value={selectedStatuts}
          onChange={setSelectedStatuts}
          placeholder="Statut"
          multiple
          width="305px"
        />

        {/* AMF */}
        <DropdownSelect
          options={AMF_OPTIONS}
          value={selectedAmf}
          onChange={setSelectedAmf}
          placeholder="AMF"
          multiple
          width="305px"
        />

        {/* Réinitialiser */}
        <AppButton
          variant="reset"
          label="Réinitialiser"
          onClick={handleReset}
          sx={{ height: '45px', width: '159px' }}
        />
      </Box>

      <UserList filters={filters} update={update} />
    </Box>
  );
};

export default Users;